import { FooterSite, HeaderSite } from "@acme/feature";
import { blogUrls } from '../../blog';
import Link from 'next/link'
import Image from 'next/image'
import { dayjs } from "@acme/util";
import type { GetStaticProps } from "next";
import Head from "next/head";

export default function BlogPage() {
    return (
        <>
            <Head>
                <title>Blog - DapperGPT | AI Tutorials, Tips & Best Practices</title>
                <meta name="description" content="Read the latest articles about AI, ChatGPT, Claude, Gemini, prompt engineering, and workflow optimization for power users." />
                <meta property="og:title" content="DapperGPT Blog - AI Tutorials & Best Practices" />
                <meta property="og:description" content="Learn how to get the most out of AI models with tips, guides, and expert insights." />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://dappergpt.com/blog" />
            </Head>
            <div>
                <HeaderSite containerClassName='bg-blue-700 !w-full min-w-full px-14' />
                <BlogList />
                <FooterSite />
            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps = () => {
    return {
        props: {},
        revalidate: 3600,
    }
}

const BlogList = () => {
    return (
        <div className="max-w-6xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto min-h-[95vh]">
            <div className="mb-10">
                <h1 className="text-3xl font-bold">Blog</h1>
                <p className="mt-1 text-gray-600 dark:text-gray-400">Read our latest news and stories.</p>
            </div>
            <div className="grid lg:grid-cols-2 gap-6">
                {blogUrls.map((url) => (
                    <Link key={url.url} className="group sm:flex" href={`/blog/${url.url}`}>
                        <div className="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
                            <Image
                                className="object-cover"
                                src={url.img}
                                alt={url.title}
                                fill
                                sizes="(max-width: 640px) 100vw, 250px"
                            />
                        </div>

                        <div className="grow">
                            <div className="p-4 flex flex-col h-full sm:p-6">
                                <h2 className="text-lg sm:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
                                    {url.title}
                                </h2>
                                <p className="mt-2 text-gray-600 dark:text-gray-400">
                                    {url.shortDesc}
                                </p>

                                <div className="mt-5 sm:mt-auto">
                                    <div className="flex items-center">
                                        <div className="ml-2.5 sm:ml-4">
                                            <p className="text-xs text-gray-500">
                                                {dayjs(url.date).format('MMMM DD, YYYY')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    )
}